// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_jumbotrons.styl
// module id = 127
// module chunks = 0